<template>
    <div class="relative mb-3 mobile:p-2.5 tablet:p-3 !pt-5 rounded-[10px] bg-[#F7F7F7]">
        <div class="flex tablet:gap-2 justify-between items-start">
            <h6 class="w-3/5 mobile:mb-2 tablet:m-0 font-roboto font-medium text-[20px] text-[#333333]">
                {{ bundle.bundle_name }}</h6>
            <div class="w-2/5 flex justify-end">
                <div class="text-left">
                    <p class="m-0 text-sm tablet:text-[16px] font-medium font-roboto w-max text-[#999999]">{{
                        bundle.bundle_month }} months
                        plan</p>
                    <h4 class="m-0 text-lg tablet:text-[20px] font-roboto font-bold text-[#333]">
                        ${{ $helper.formatAmount(bundle.bundle_amount) }}/mo</h4>
                </div>
            </div>
        </div>
        <div class="flex flex-col gap-[5px] largeDesktop:gap-[10px] mb-2 largeDesktop:mb-3"
            v-for="(items, trade) in getAddonData(bundle.items)" :key="trade">
            <h6
                class="m-0 text-[12px] rounded-full px-[10px] py-[2px] inline-block w-max shadow-[0_0_4px_0_#00000026] text-[#fff] bg-customBlue-100">
                {{ trade }}</h6>
            <div v-for="(plan, index) in items" :key="index" class="flex items-center gap-[5px]">
                <img src="../../assets/images/check-double-purple.png" alt="Check Icon" class="w-[16px] h-[16px]">
                <span class="text-[14px] font-roboto font-normal     text-[#333]">{{ plan.plan_name }}</span>
            </div>
        </div>
        <div v-if="bundle.is_show_quantity == 0" class="absolute -top-[16px] right-[16px]">
            <!-- min 640px screen size   -->
            <button type="button" @click="updateCounter('remove')"
                class="transform lg:hover:scale-[1.1] active:scale-[0.98] duration-300 group h-8 w-8 mobile:hidden laptop:flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 bg-white border-[#FE5000] hover:!bg-[#FE5000]">
                <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                    class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 group-hover:hidden object-contain">
                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                    class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 hidden group-hover:!block">
            </button>
            <!-- after 640px screens -->
            <button type="button" @click="updateCounter('remove')"
                class="transform lg:hover:scale-[1.1] active:scale-[0.98] duration-300 transition-all group h-8 w-8  laptop:hidden mobile:flex items-center justify-center rounded-full focus:outline-0 border-1 border-[#FE5000] bg-[#FE5000]">
                <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                    class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 ">
            </button>
        </div>

        <div class="flex items-center gap-[10px]">
            <div class="w-max laptop:w-full mobile:flex mobile:justify-between mobile:items-center mobile:w-full ">
                <quantityCounter v-if="bundle.is_show_quantity == 1" :quantity="bundle.bundle_quantity"
                    @update-counter="updateCounter" />
                <!-- <button v-else type="button" @click="updateCounter('remove')"
                    class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#FE5000] hover:bg-[#FE5000]">
                    <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                        class="mobile:!w-5 mobile:1h-5 tablet:w-7 tablet:h-7 group-hover:hidden object-contain">
                    <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                        class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 hidden group-hover:!block">
                </button> -->
                <h2 v-if="bundle.bundle_quantity > 1" class="m-0 text-[20px] font-bold font-roboto text-customBlue-100">
                    ${{
                        $helper.formatAmount(bundle.bundle_amount * bundle.bundle_quantity) }}/mo
                </h2>
            </div>
            <div v-if="showViewDetail"
                class="group cursor-pointer w-[35px] h-[35px] flex items-start justify-center rounded-full shadow-[0_0_4px_0_#00000026] p-[5px] ttransition duration-300 bg-[#fff] hover:bg-[#7695FF]">
                <img src="../../assets/images/eye-purple-icon.svg" alt="" class="w-full h-full group-hover:hidden">
                <img src="../../assets/images/eye-white-icon.svg" alt="" class="w-full h-full hidden group-hover:block">
            </div>
        </div>
    </div>
</template>


<script>
import quantityCounter from '../partialComponent/quantityCounter.vue';
// import trashIcon from  "../../assets/images/delete-icon-3.png"

export default {
    components: {
        quantityCounter
    },
    props: {
        bundle: Object,
        isSelected: Boolean,
        updateCart: Function,
        updateCard: Object,
        showViewDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localObject: null
        }
    },

    watch: {
        // updateCard: function (data) {
        //     if (data && this.localObject) {
        //         this.plan.quantity = this.localObject.quantity
        //     }
        //     // this.localObject = null
        // },
    },

    methods: {

        getAddonData(data) {
            const groupedData = data.reduce((acc, item) => {
                const key = item.trade_name;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(item);
                return acc;
            }, {});
            return groupedData
        },
        updateCounter(option) {

            this.localObject = JSON.parse(JSON.stringify(this.bundle))

            if ((option == "decrement" || option == "remove") && this.localObject.bundle_quantity == 1) {
                this.$dialog.show({
                    title: "Delete Item",
                    text: `
                    <div class="flex flex-col items-center justify-center gap-4 text-gray-700 text-[16px]">
                        <img src=${require('../../assets/images/delete-icon-with-bg.png')} style="width:60px; height:auto;">
                        Are you sure you want to delete this item?
                    </div>`,
                    html: true,
                    onConfirm: () => {
                        this.localObject.bundle_quantity = 0
                        this.updateCart(option, {
                            id: this.localObject.bundle_id,
                            quantity: this.localObject.bundle_quantity,
                            partner_id: this.localObject.partner_id,
                            type: 'bundle'
                        })
                    },
                });
            } else {
                if (option == "increment") {
                    this.localObject.bundle_quantity++
                } else if (option == "decrement" || option == "remove") {
                    if (this.localObject.bundle_quantity > 1) {
                        this.localObject.bundle_quantity--
                    } else {
                        this.localObject.bundle_quantity = 0
                    }
                } else {
                    this.localObject.bundle_quantity = 0
                }
                this.updateCart(option, {
                    id: this.localObject.bundle_id,
                    quantity: this.localObject.bundle_quantity,
                    partner_id: this.localObject.partner_id,
                    type: 'bundle'
                })
            }
        },
    }
}
</script>